import * as dataManagement from '../services/dataManagement';

export default {
  namespace: 'dataManagement',
  state: {
    storesList: [],
    storesTotal: 0,
  },
  effects: {
    *queryCategoryPage({ payload: { value } }, { put, call }) {
      const response = yield call(dataManagement.queryCategoryPage, value);
      yield put({
        type: 'save',
        payload: {
          storesList: response.data.data,
          // storesPageSize: response.data.pageSize,//分页大小，10、50
          storesTotal: response.data.total, //总条数
          // storesPageNum: response.data.pageNum, //当前分页
        },
      });
    },
    *addNewProduct({ payload: { values }, callback }, { call }) {
      const response = yield call(dataManagement.addNewProduct, values);
      callback && callback(response?.code);
    },
    *updateNewProduct({ payload: { values }, callback }, { call }) {
      const response = yield call(dataManagement.updateNewProduct, values);
      callback && callback(response?.code);
    },
    *queryNewProductDetail({ payload: { values }, callback }, { call }) {
      const response = yield call(dataManagement.queryNewProductDetail, values);
      callback && callback(response);
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};